<div class="container-fluid" style="background-color: #1d2229">
    <div class="row">
        <div class="col-sm-2">
            <div class="content">
                <div class="container-lg text-center" style="background-color: #1d2229">
                    <div class="row">
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 51]"
                                [ngStyle]="{ color: statusDocks(51) }">
                                Doca 1
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 52]"
                                [ngStyle]="{ color: statusDocks(52) }">
                                Doca 2
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 53]"
                                [ngStyle]="{ color: statusDocks(53) }">
                                Doca 3
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 54]"
                                [ngStyle]="{ color: statusDocks(54) }">
                                Doca 4
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" (click)="openPlanning()">
                                Time Table
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-sm-10">
            <router-outlet></router-outlet>
        </div>

    </div>
</div>

<app-motores-transmissao-time-table *ngIf="timeTableIsVisible"></app-motores-transmissao-time-table>